import   axios                from 'axios';

import { API_URLS           } from '../urls';
import { BackendResponse    ,
         handleError        } from '../../dataTypes/backendServicesManagment/types';

import { SentEmail           } from '../../dataTypes/sentEmailManagment/types';

const transformSentEmail = (data: any): SentEmail => ({
  id       : data.id ,
  type     : data.type ?? '' ,
  subject  : data.subject ?? '' ,
  date     : data.date ? new Date(data.date) : null ,
  bodyHtml : data.bodyHtml ?? '' ,
});

export interface BackendResponse_SentEmailList extends BackendResponse<SentEmail[]> {}

export const getSentEmails = async (email: string): Promise<BackendResponse_SentEmailList> => {

  const url = `${API_URLS.getSentEmailsByEmail}?email=${encodeURIComponent(email)}`;

  try {
    const response = await axios.get(url);

    if (response.status === 200 && Array.isArray(response.data)) {
      return {
        code: 1,
        comment: 'Les emails ont été récupérés avec succès.',
        payload: response.data.map(transformSentEmail),
      };
    }
    return handleError<SentEmail[]>(response.status, 'Réponse non-200.', []);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError<SentEmail[]>(-101, error.response?.data?.detail ?? error.message, []);
    }
    return handleError<SentEmail[]>(-102, 'Erreur inconnue.', []);
  }
};
